var Router = function () {
    var self = this;

    this.routes = {
        'login': 'login',
        'request-account': 'request-account',
        'existing-orders': 'existing-orders',
        'create-new-order': 'create-new-order',
        'update-existing-order': 'update-existing-order',
        'your-addresses': 'your-addresses',
        'reset-password': 'reset-password'
    };

    this.login_route = 'login';
    this.default_route = 'existing-orders';

    this.isExistingRoute = function (rout) {
        return self.routes[rout] !== undefined;
    };

    this.getDefaultRoute = function () {
        return self.routes[self.default_route];
    };
    this.getLoginRout = function () {
        return self.routes[self.login_route];
    };

    this.goTo = function (alias, parameters) {
        if (alias === 'default') {
            pager.navigate(self.getDefaultRoute());
            pager.goTo(self.getDefaultRoute());
        } else {
            var route = self.routes[alias];
            if (parameters) {
                route += '?';
                for (var key in parameters) {
                    route += key + '=' + parameters[key] + '&';
                }
                route = route.slice(0, -1);
            }

            pager.navigate(route);
            pager.goTo(route);
        }
    }
};

module.exports = new Router();


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/services/router.js
// module id = 4
// module chunks = 0